<!--
  A view that awaits the scan of a passenger boarding pass
-->
<template>
  <div>
    <div class="boarding_pass_scanning_form">
      <div class="boarding_pass_scan_image">
        <img src="@/assets/theme/images/qr-scanning-load-icon.gif"/>
      </div>
      <h2 class="subtitle">{{$t(`${pagei18nKey}.scanToGetStarted`)}}</h2>
      <div>{{$t(`${pagei18nKey}.pleaseScanDescriptionText`)}}</div>
      <div class="section_subtitle">{{$t(`${pagei18nKey}.noBoardingPass`)}}</div>
      <!-- no boarding pass, link to enter manually -->
      <div class="boarding_pass_enter_manually">
        <span
          @click="onEnterDetailsManuallyClicked"
          class="link-text">
          {{$t(`${pagei18nKey}.enterFlightDetailsManually`)}}
        </span>
      </div>
    </div>
    <!-- hidden input to read a barcode -->
    <input
      class="boarding_pass_input"
      id="boardingCard"
      v-model="boardingCardText"
      autofocus
      type="text"
      autocapitalize="off"
      autocomplete="nope"
      spellcheck="false"
      autocorrect="off"
      onblur="this.focus()" />
  </div>

</template>
<script>
  // import api from '@/api/api'
  // import { Validator } from 'vee-validate'
  import {BoardingPass} from '@/model/boardingPass'

  export default {
    name: 'BoardingPassScanningView',
    components: {
    },
    computed: {
      boardingCardText: {
        /**
         * Gets current stored firstName
         */
        get () {
          return this.boardingCardRaw
        },

        /**
         * Sets firstName value
         *
         * @param {string} value - Value to set firstName to
         */
        set (value) {
          this.boardingCardRaw = value
          console.log('boarding card input: ' + value)
          if (!this.boardingPass) {
            this.boardingPass = BoardingPass.rawToJson(value)
            if (this.boardingPass) {
              console.log(this.boardingPass)
              this.$store.commit('setBoardingPass', this.boardingPass)
              this.boardingCardText = ''
              // we have parsed data into a boarding pass so move onto the confirmation screen
              // wait a second in case further text (that we don't need) is being read from barcode.
              setTimeout(() => this.$router.push('/boarding-pass-confirm'), 1000)
            }
          }
        }
      }
    },

    data: function () {
      return {
        pagei18nKey: 'message.boardingPassScan',
        loading: true,
        activeId: null,
        languages: [],
        boardingPass: null
      }
    },
    methods: {
      focusInput () {
        console.log('focus')
        document.getElementById('boardingCard').focus()
        // this.$refs.boardingCard.focus()
      },
      onEnterDetailsManuallyClicked () {
        console.log('on enter details manually clicked')
        // clear boarding pass!
        this.$store.commit('clearBoardingPassData')
        // and move on so user can enter manual details
        this.$router.push('/flight-details')
      }
    },
    beforeCreate () {
      console.log('scanning create')
      // clear previous boarding pass!
      this.$store.commit('setBoardingPass', null)
    },
    mounted () {
      console.log('scanning view mounted')
      this.loading = true
      this.focusInput()
      document.getElementById('boardingCard').value = ''
    }
  }
</script>

<style lang="scss">
  @import "../../assets/sass/main.scss";

.boarding_pass_scanning_form {
  border-bottom: $default-border-style;
  @extend %app_form_container;
  text-align: center;
}

.boarding_pass_scan_image img{
    width: $dims-boarding-pass-scan-icon-width;
    height: $dims-boarding-pass-scan-icon-height;
    margin-bottom: $dims-spacing-small; 
}

.boarding_pass_input {
  // keep it in form but smallest possible, 
  // invisible for user
  opacity: 0;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

.section_subtitle {
    @extend .subtitle;
    padding-top: $dims-spacing-large;
    margin-top: $dims-spacing-large;
    border-top: $default-border-style;
}

.boarding_pass_enter_manually {
    text-align: center;

    .link-text {
      font-weight: $semibold-font-weight;
      color: $quaternary-text-color;
      cursor: pointer;
    }
  }

</style>
